import React, { useEffect, useState } from "react";
import classes from "./location.module.css";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { LOCATION } from "../../../api-calls/api-urls";
import {
  Link,
  Paper,
  Chip,
  Button,
  Typography,
  Tooltip,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getLanguagedataFunction } from "../../../utilities/language";
import { useDispatch, useSelector } from "react-redux";
import {
  checkOnline,
  formatBytes,
  getChipColor,
  formatStatusLabel,
} from "../../../utilities/commonFunctions";
import RecorderCard from "./audioRecorder";
import {
  BrudCrumbBackIcon,
  BrudCrumbNextIcon,
  DeleteBinIcons,
  EditPenIcon,
} from "../../../components/Icons";
import DeleteConformation from "./DeleteConformation";
import SmallViewRoutes from "./SmallViewRoute";
import { decodeFileName } from "../../../utilities/fileName";
import { isImageAttachment, resolveAttachmentUrl } from "../../../utilities/attachments";
import AttachmentTile from "../../../components/AttachmentTile";
import RepeatSeriesCard from "./RepeatSeriesCard";
// import ViewRoute from "../Maps/viewRoute";

const LocationDetailsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentLocation, setCurrentLocation] = useState();
  const [modleToggle, setModalToggle] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const ln = useSelector((state) => state.allUsers.language_json);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  useEffect(() => {
    const path = window.location.pathname;
    getOneLocationdata(path.toLowerCase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!currentLocation]);

  // eslint-disable-next-line unused-imports/no-unused-vars
  const handleDeleteLocation = async (item) => {
    setModalToggle(true);
  };

  const modalClose = () => {
    setModalToggle(false);
  };

  const getOneLocationdata = async (path) => {
    try {
      const arr = path.split("/");
      console.log(arr[arr?.length - 1]);
      const { data } = await authApi.get(
        `${LOCATION}/${arr[arr?.length - 1]}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      );
      console.log(data.data);
      setCurrentLocation(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleViewonGoogleMap = () => {
    console.log("this functions triffers");
    if (
      currentLocation.location_info &&
      currentLocation.location_info.lat &&
      currentLocation.location_info.lng
    ) {
      window.open(
        `https://www.google.com/maps/place/${currentLocation.location_info.lat},${currentLocation.location_info.lng}/@${currentLocation.location_info.lat},${currentLocation.location_info.lng},16z`,
        "_blank",
      );
    }
  };

  const handleDeleteImage = async () => {
    try {
      const userEntry = {
        images: [],
      };
      await authApi.put(`${LOCATION}/${currentLocation._id}`, userEntry, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      getOneLocationdata(window.location.pathname.toLowerCase());
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditClick = (item) => {
    navigate(`/location/update/${item.slug.toLowerCase()}`);
  };

  const handleReassign = (item) => {
    navigate(`/location/reassign/${item.slug.toLowerCase()}`);
  };
  const filenameConvert = (filename) => {
    filename = decodeFileName(filename) || "";
    const spliteName = filename.split(".");
    console.log(spliteName);

    if (spliteName[0].length > 10) {
      filename = filename.substring(0, 10);
      return filename + "." + spliteName[spliteName.length - 1];
    }
    return filename;
  };
  return (
    <div>
      {currentLocation && ln ? (
        <div>
          <Box className={classes.brudCrumb} sx={{ mb: 3 }}>
            <span onClick={() => navigate(-1)}>
              <BrudCrumbBackIcon />
            </span>
            <span
              onClick={() => navigate("/location")}
              className={classes.form_lable}
              style={{ color: "#0A1F41" }}
            >
              {ln.locations}
            </span>
            <BrudCrumbNextIcon />
            <span className={classes.form_lable}>
              {currentLocation ? currentLocation.title : ""}
            </span>
          </Box>
          <Paper className={`${classes.DetailPageMainDiv}`}>
            <div className={classes.imageText}>
              <Typography className={classes.createLocationheading1}>
                {ln.location_details}
              </Typography>
              <Link
                className={classes.LinkEdit}
                onClick={() => handleEditClick(currentLocation)}
              >
                <EditPenIcon /> {ln.edit}
              </Link>
            </div>
            <Box sx={{ mt: 2 }}>
              <div className={classes.memberCardText}>
                <Typography className={classes.memberCardTextHeading}>
                  {ln.location}
                </Typography>
              </div>
              <div className={`${classes.imageText} ${classes.TextContainer1}`}>
                <div>
                  <Typography className={classes.form_lable}>
                    {ln.location_id}
                  </Typography>
                  <Typography
                    className={`${classes.form_lable} ${classes.detailsText1}`}
                  >
                    {currentLocation._id.substring(0, 6)}
                  </Typography>
                </div>
                <div>
                  <Typography className={classes.form_lable}>
                    {ln.title}
                  </Typography>
                  <Typography
                    className={`${classes.form_lable} ${classes.detailsText1}`}
                  >
                    {currentLocation.title}
                  </Typography>
                </div>
                <div>
                  <Typography className={classes.form_lable}>
                    {ln.assigned_on}
                  </Typography>
                  <Typography
                    className={`${classes.form_lable} ${classes.detailsText1}`}
                  >
                    {moment(currentLocation.assigned_on).format(
                      "DD MMM YYYY,hh:mm A",
                    )}
                  </Typography>
                </div>
                <div style={{ minWidth: "18%", maxWidth: "300px" }}>
                  <Typography className={classes.form_lable}>
                    {ln.description}
                  </Typography>
                  <Typography
                    className={`${classes.form_lable} ${classes.detailsText1}`}
                  >
                    {currentLocation.description}
                  </Typography>
                </div>
                <div>
                  <Typography className={classes.form_lable}>
                    {ln.status}
                  </Typography>
                  <Typography
                    className={`${classes.form_lable} ${classes.detailsText1}`}
                  >
                    <Chip
                      className={classes.locationStatusChip}
                      label={formatStatusLabel(currentLocation.status)}
                      size="small"
                      style={getChipColor(currentLocation.status)}
                    />
                  </Typography>
                </div>
              </div>
              {currentLocation.series && (
                <RepeatSeriesCard
                  series={currentLocation.series}
                  onChanged={() =>
                    getOneLocationdata(window.location.pathname.toLowerCase())
                  }
                />
              )}
            </Box>
            <Box sx={{ mt: 6 }}>
              <div className={classes.memberCardText}>
                <Typography className={classes.memberCardTextHeading}>
                  {ln.customer_details}
                </Typography>
              </div>
              <div className={classes.customerDetails1}>
                <div>
                  <Typography className={classes.form_lable}>
                    {ln.customer_address}
                  </Typography>
                  <Tooltip title={currentLocation.address}>
                    <Typography
                      className={`${classes.form_lable} ${classes.detailsText1}`}
                      noWrap
                      style={{
                        overflow: "hidden",
                        width: "150px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {currentLocation.address}
                    </Typography>
                  </Tooltip>
                </div>
                <div>
                  <Typography className={classes.form_lable}>
                    {ln.map_location}
                  </Typography>
                  <Link
                    className={classes.LinkbtnViewGooleMap}
                    onClick={() => handleViewonGoogleMap()}
                  >
                    {ln.view_google_map}
                  </Link>
                </div>
                <div style={{ minWidth: "18%", maxWidth: "300px" }}>
                  <Typography className={classes.form_lable}>
                    {ln.mobile_number}
                  </Typography>
                  <Typography
                    className={`${classes.form_lable} ${classes.detailsText1}`}
                  >
                    {currentLocation.mobile_number}
                  </Typography>
                </div>
              </div>
            </Box>
            <Box sx={{ mt: 6 }}>
              {/* <div
                className={`${classes.memberCardText} ${classes.viewRoutContainer}`}
              >
                <Typography className={classes.memberCardTextHeading}>
                  {ln.team_member_details}
                </Typography>
                <Typography
                  className={classes.viewRouteText}
                  onClick={() => handleViewRoute()}
                >
                  <ViewRouteIcon />
                  <span>View route</span>
                </Typography>
              </div> */}
              <div className={`${classes.imageText} ${classes.TextContainer2}`}>
                <div>
                  <Typography className={classes.form_lable}>
                    {ln.assigned_to}
                  </Typography>
                  <Typography
                    className={`${classes.form_lable} ${classes.detailsText1}`}
                  >
                    {currentLocation.employee.name} (
                    {checkOnline(currentLocation.employee?.user_id) ===
                    "checkin"
                      ? "Online"
                      : "Offline"}
                    )
                  </Typography>
                </div>
                <div>
                  <Typography className={classes.form_lable}>
                    {ln.team}
                  </Typography>
                  <Typography
                    className={`${classes.form_lable} ${classes.detailsText1}`}
                  >
                    {currentLocation.employee.department.department_name}
                  </Typography>
                </div>
                <div>
                  <Typography className={classes.form_lable}>
                    {ln.reached_on}
                  </Typography>
                  <Typography
                    className={`${classes.form_lable} ${classes.detailsText1}`}
                  >
                    {currentLocation.status === "completed"
                      ? moment(
                          currentLocation?.userLocation?.reached_date,
                        ).format("DD MMM YYYY,hh:mm A")
                      : "-"}
                  </Typography>
                </div>
              </div>
            </Box>
            <Box sx={{ mt: 6 }}>
              <div className={classes.memberCardText}>
                <Typography className={classes.memberCardTextHeading}>
                  {ln.other_details}
                </Typography>
              </div>
              <div
                className={`${classes.mapandImageContainer} ${classes.TextContainer3}`}
              >
                <div>
                  <RecorderCard audio={currentLocation} title="Audio note" />
                </div>
                {currentLocation &&
                currentLocation.images &&
                currentLocation.images.length > 0 ? (
                  <div className={classes.subImageContainer}>
                    {/* Documents open in a new tab from the tile; the
                        preview dialog below is for photos only. */}
                    {isImageAttachment(currentLocation.images[0]) ? (
                      <img
                        src={resolveAttachmentUrl(currentLocation.images[0])}
                        width="250px"
                        height="150px"
                        style={{ maxHeight: "250px", cursor: "pointer" }}
                        alt={decodeFileName(currentLocation.images[0]?.originalname)}
                        onClick={() => setPreviewOpen(true)}
                      />
                    ) : (
                      <AttachmentTile
                        item={currentLocation.images[0]}
                        url={resolveAttachmentUrl(currentLocation.images[0])}
                      />
                    )}
                    <div className={classes.imageText}>
                      <Tooltip title={decodeFileName(currentLocation.images[0]?.originalname)}>
                        <Typography
                          className={`${classes.form_lable} ${classes.detailsText1}`}
                          noWrap
                          style={{
                            overflow: "hidden",
                            width: "150px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {filenameConvert(
                            currentLocation.images[0]?.originalname,
                          )}
                        </Typography>
                      </Tooltip>

                      <div style={{ display: "flex", columnGap: "10px" }}>
                        <Typography
                          style={{ fontSize: "13px", marginTop: "6px" }}
                        >
                          {currentLocation.images[0].size
                            ? formatBytes(currentLocation.images[0].size)
                            : ""}
                        </Typography>
                        {/* {item.size ? (
                            <Typography className={classes.form_lable}>
                              {formatBytes(currentLocation.images[0].size)}
                            </Typography>
                          ) : null} */}
                        <Typography
                          className={`${classes.form_lable} ${classes.ImageDeleteBtn}`}
                          style={{ marginTop: "4px" }}
                          // onClick={() =>
                          //   remove(currentLocation.images[0].filename)
                          // }
                        >
                          <span onClick={() => handleDeleteImage()}>
                            <DeleteBinIcons />
                          </span>
                        </Typography>
                      </div>
                    </div>
                  </div>
                ) : null}
                {currentLocation.location_info ? <SmallViewRoutes /> : null}
              </div>
            </Box>
            <Box sx={{ mt: 3, mb: 2 }}>
              <div className={classes.createLocationbtnsectin}>
                <Button
                  variant="outlined"
                  onClick={() => handleDeleteLocation(currentLocation)}
                >
                  {ln.delete_location}
                </Button>
                <Button
                  variant="contained"
                  onClick={() => handleReassign(currentLocation)}
                >
                  {ln.reassign_location}
                </Button>
              </div>
            </Box>
          </Paper>
          {modleToggle ? (
            <DeleteConformation
              item={currentLocation}
              modalClose={modalClose}
            />
          ) : null}
          <Dialog
            open={previewOpen}
            onClose={() => setPreviewOpen(false)}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {decodeFileName(currentLocation?.images?.[0]?.originalname)}
              <IconButton onClick={() => setPreviewOpen(false)} size="small">
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent
              dividers
              style={{
                minHeight: 300,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={resolveAttachmentUrl(currentLocation?.images?.[0])}
                alt={decodeFileName(currentLocation?.images?.[0]?.originalname)}
                style={{ maxWidth: "100%", maxHeight: 500 }}
              />
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={() =>
                  window.open(
                    resolveAttachmentUrl(currentLocation?.images?.[0]),
                    "_blank",
                  )
                }
              >
                Download
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      ) : null}
    </div>
  );
};

export default LocationDetailsPage;
